<mat-tab-group (selectedTabChange)="onTabChange($event)">
  <mat-tab label="Pending Notifications">
    <div style="padding: 20px;">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" style="margin-bottom: 20px;">
        <mat-form-field appearance="fill">
          <mat-label>Cooldown Period (Days)</mat-label>
          <input matInput type="number" [(ngModel)]="cooldownDays" (change)="loadPending()">
          <button *ngIf="cooldownDays != null" matSuffix mat-icon-button type="button" aria-label="Clear" (click)="$event.stopPropagation(); cooldownDays = null; loadPending()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Limit</mat-label>
          <mat-select [(ngModel)]="limit" (selectionChange)="loadPending()">
            <mat-option *ngFor="let opt of limitOptions" [value]="opt">
              {{opt}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <button mat-raised-button color="primary" (click)="loadPending()" [disabled]="loadingPending">Refresh</button>
      </div>

      <div style="margin-bottom: 15px;">
        <button mat-raised-button (click)="selectAll()">Select All</button>
        <button mat-raised-button color="accent" (click)="sendNotifications()" [disabled]="selectedUserIds.size === 0 || sending" style="margin-left: 10px;">
          Send Push Notifications ({{selectedUserIds.size}})
        </button>
      </div>

      <div *ngIf="loadingPending">Loading...</div>

      <table *ngIf="!loadingPending && pendingUsers.length > 0" class="mat-elevation-z8" style="width: 100%; text-align: left;">
        <tr>
          <th>Select</th>
          <th>ID</th>
          <th>Locale</th>
          <th>Balance</th>
          <th>Earnings</th>
          <th>Last Push</th>
        </tr>
        <tr *ngFor="let user of pendingUsers">
          <td>
            <mat-checkbox [checked]="selectedUserIds.has(user._id)" (change)="toggleSelection(user._id)"></mat-checkbox>
          </td>
          <td><a [routerLink]="['/users', user._id]">{{user._id}}</a></td>
          <td>{{user.locale}}</td>
          <td>{{user.private_info?.balance || 0}}</td>
          <td>{{user.private_info?.earningsBalance || 0}}</td>
          <td>{{user.lastFCM | date:'short'}}</td>
        </tr>
      </table>
      <div *ngIf="!loadingPending && pendingUsers.length === 0">No users found.</div>
    </div>
  </mat-tab>

  <mat-tab label="Reacted Users">
    <div style="padding: 20px;">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" style="margin-bottom: 20px;">
        <mat-form-field appearance="fill">
          <mat-label>Limit</mat-label>
          <mat-select [(ngModel)]="limit" (selectionChange)="loadReacted()">
            <mat-option *ngFor="let opt of limitOptions" [value]="opt">
              {{opt}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <button mat-raised-button color="primary" (click)="loadReacted()" [disabled]="loadingReacted">Refresh</button>
      </div>
      
      <div *ngIf="loadingReacted">Loading...</div>

      <table *ngIf="!loadingReacted && reactedUsers.length > 0" class="mat-elevation-z8" style="width: 100%; text-align: left;">
        <tr>
          <th>ID</th>
          <th>Locale</th>
          <th>Balance</th>
          <th>Earnings</th>
          <th>Last Push</th>
          <th>Last Visit</th>
        </tr>
        <tr *ngFor="let user of reactedUsers">
          <td><a [routerLink]="['/users', user._id]">{{user._id}}</a></td>
          <td>{{user.locale}}</td>
          <td>{{user.private_info?.balance || 0}}</td>
          <td>{{user.private_info?.earningsBalance || 0}}</td>
          <td>{{user.lastFCM | date:'short'}}</td>
          <td>{{user.last_visit | date:'short'}}</td>
        </tr>
      </table>
      <div *ngIf="!loadingReacted && reactedUsers.length === 0">No reacted users found.</div>
    </div>
  </mat-tab>
</mat-tab-group>
